import { jsx as _jsx } from "react/jsx-runtime";
import { FaUndoAlt } from "react-icons/fa";
import { IoArrowForwardCircleSharp, IoFlashOffSharp, IoFlashSharp, IoPencilOutline, IoTrashOutline } from "react-icons/io5";
import { MdAdd, MdAddBox, MdAddCircle, MdArrowBack, MdArrowBackIos, MdArrowDownward, MdArrowForward, MdArrowUpward, MdBolt, MdCheck, MdChevronRight, MdClose, MdContentCopy, MdCrop169, MdCropDin, MdCropSquare, MdDescription, MdExpandLess, MdExpandMore, MdFormatListBulleted, MdHorizontalRule, MdInfoOutline, MdInsertDriveFile, MdLayersClear, MdLock, MdModeEditOutline, MdOfflineBolt, MdOndemandVideo, MdOpenInBrowser, MdOpenInNew, MdOutlineAdd, MdOutlineBurstMode, MdOutlineCloseFullscreen, MdOutlineCode, MdOutlineFileDownload, MdOutlineFileUpload, MdOutlineFilterNone, MdOutlineImage, MdOutlineRateReview, MdOutlineSelectAll, MdOutlineStorage, MdOutlineSubtitles, MdOutlineTableChart, MdOutlineTableRows, MdOutlineTitle, MdOutlineViewDay, MdOutlineWidthFull, MdPhotoFilter, MdRedo, MdRefresh, MdSmartButton, MdStarHalf, MdStayCurrentLandscape, MdStayCurrentPortrait, MdStoreMallDirectory, MdSubdirectoryArrowLeft, MdTextFields, MdUndo } from "react-icons/md";
import tw from "tailwind-styled-components";
import Gear from "./custom/Gear";
import Goal from "./custom/Goal";
import Grid from "./custom/Grid";
import Menu from "./custom/Menu";
import Pencil from "./custom/Pencil";
import Photo from "./custom/Photo";
import Plus from "./custom/Plus";
import Polaroid from "./custom/Polaroid";
import Text from "./custom/Text";
/**
 * PLEASE READ
 *
 * To add additional icons import them from react-icons and add them
 * to the `Icons` map below. Then you can reference the new icon(s)
 * by the import name.
 */ const Io5Icons = {
    IoArrowForwardCircleSharp,
    IoFlashOffSharp,
    IoFlashSharp,
    IoPencilOutline,
    IoTrashOutline
};
const MdIcons = {
    FaUndoAlt,
    MdAdd,
    MdAddBox,
    MdAddCircle,
    MdArrowBack,
    MdArrowBackIos,
    MdArrowDownward,
    MdArrowForward,
    MdArrowUpward,
    MdBolt,
    MdCheck,
    MdChevronRight,
    MdClose,
    MdContentCopy,
    MdCrop169,
    MdCropDin,
    MdCropSquare,
    MdDescription,
    MdExpandLess,
    MdExpandMore,
    MdFormatListBulleted,
    MdHorizontalRule,
    MdInfoOutline,
    MdInsertDriveFile,
    MdLayersClear,
    MdLock,
    MdModeEditOutline,
    MdOfflineBolt,
    MdOndemandVideo,
    MdOpenInBrowser,
    MdOpenInNew,
    MdOutlineAdd,
    MdOutlineBurstMode,
    MdOutlineCloseFullscreen,
    MdOutlineCode,
    MdOutlineFileDownload,
    MdOutlineFileUpload,
    MdOutlineFilterNone,
    MdOutlineImage,
    MdOutlineRateReview,
    MdOutlineSelectAll,
    MdOutlineStorage,
    MdOutlineSubtitles,
    MdOutlineTableChart,
    MdOutlineTableRows,
    MdOutlineTitle,
    MdOutlineViewDay,
    MdOutlineWidthFull,
    MdPhotoFilter,
    MdRedo,
    MdRefresh,
    MdSmartButton,
    MdStarHalf,
    MdStayCurrentLandscape,
    MdStayCurrentPortrait,
    MdStoreMallDirectory,
    MdSubdirectoryArrowLeft,
    MdTextFields,
    MdUndo
};
const CustomIcons = {
    SwPencil: Pencil,
    SwGear: Gear,
    SwGoal: Goal,
    SwText: Text,
    SwGrid: Grid,
    SwMenu: Menu,
    SwPlus: Plus,
    SwPolaroid: Polaroid,
    SwPhoto: Photo
};
export const Icons = {
    ...Io5Icons,
    ...MdIcons,
    ...CustomIcons
};
const Base = tw.div`
${({ $flipHorizontal })=>$flipHorizontal ? `scale-x-[-1]` : ""}
  text-md
  ${({ $color })=>$color}
`;
const colors = {
    white: "text-white",
    whiteOpacity20: "text-white text-opacity-20",
    whiteOpacity80: "text-white text-opacity-80",
    whiteOpacity90: "text-white text-opacity-90",
    accentLight: "text-accent-light",
    accent: "text-accent-primary",
    accentDark: "text-accent-dark",
    alert: "text-alert-primary",
    dark: "text-[#13151A]"
};
const sizes = {
    xs: {
        fontSize: "0.75rem",
        lineHeight: "1rem"
    },
    sm: {
        fontSize: "0.875rem",
        lineHeight: "1.25rem"
    },
    base: {
        fontSize: "1rem",
        lineHeight: "1.5rem"
    },
    lg: {
        fontSize: "1.125rem",
        lineHeight: "1.75rem"
    },
    xl: {
        fontSize: "1.25rem" /* 20px */ ,
        lineHeight: "1.75rem" /* 28px */ 
    },
    ["2xl"]: {
        fontSize: "1.5rem" /* 24px */ ,
        lineHeight: "2rem" /* 32px */ 
    },
    ["3xl"]: {
        fontSize: "1.875rem" /* 30px */ ,
        lineHeight: "2.25remm" /* 36px */ 
    }
};
const Icon = ({ name, color = "accentLight", size = "base", flipHorizontal = false })=>{
    const Icon = Icons[name];
    if (!Icon) return null;
    const textColor = colors[color];
    const fontSize = sizes[size]?.fontSize;
    const lineHeight = sizes[size]?.lineHeight;
    return /*#__PURE__*/ _jsx(Base, {
        "aria-label": name,
        $color: textColor,
        $flipHorizontal: flipHorizontal,
        children: /*#__PURE__*/ _jsx(Icon, {
            style: {
                fontSize,
                lineHeight
            }
        })
    });
};
export default Icon;
